"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

exports.default = reducePropsToState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducePropsToState(propsList) {
    var defs = {};
    var symbols = {};
    propsList.forEach(function (props) {
        var id = props.id,
            spriteDefinitions = props.defs,
            render = props.render;

        (0, _assign2.default)(defs, spriteDefinitions);
        symbols[id] = render;
    });
    return { defs: defs, symbols: symbols };
}
//# sourceMappingURL=reducePropsToState.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/targets/reducePropsToState.js
 ** module id = 359
 ** module chunks = 0
 **/